module.exports = __webpack_public_path__ + "static/media/our-values.c955beef.jpg";